import { ComponentProps } from 'react';
import { TurnaroundEntityButton } from '../TurnaroundEntityButton/TurnaroundEntityButton';
import { useLanguage } from 'context/AppContext';

type Props = ComponentProps<typeof TurnaroundEntityButton>;

export const TurnaroundImplants = ({ ...props }: Props) => {
  const lang = useLanguage()[0].TurnaroundImplants;

  return <TurnaroundEntityButton {...props}>{lang.sterileImplants}</TurnaroundEntityButton>;
};
